module.exports = __webpack_public_path__ + "下载.png?26462c917507281ba3da5a94fc3f596c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/下载.png
// module id = 706
// module chunks = 0